/* Copyright Information: Created by BuyGroup */
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Container,
  CardHeader,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../components/common/breadcrumb";
import trimObj from "../components/common/TrimData";
import { Formik, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import validationSchema from "./GroupValidationSchema";
import { productList } from "../services/ProductServices";
import { getInfluencersForProducts } from "../services/InfluencerServices";
import { createGroup } from "../services/GroupServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import DeleteQuantity from "./DeleteQuantity";
import moment from "moment";
import { setMinutes, setHours, setSeconds } from "date-fns";
import CreatableSelect from "react-select/creatable";
import "./Group.css";

toast.configure();

const isPriceGreaterThanSellingPrice = (levels, price) => {
  if (levels.length > 0) {
    return levels.some(
      (level) => parseFloat(level.discount_percent) > parseFloat(price)
    );
  }
  return false;
};

const isAmazonProduct = (value) => {
  if (typeof value === "string") {
    return ["1", "true", "yes"].includes(value.toLowerCase());
  }

  return value === true || value === 1;
};

const AddGroup = (props) => {
  const [isLoading, setLoading] = useState(false); //loading state
  const [isDisable, setDisable] = useState(false); // for disable add button
  const [errorMessage, setErrorMessage] = useState(""); //for from error message
  const [selectedProduct, setProduct] = useState(""); // slected product
  const [discountErrorMessage, setDiscountErrorMessage] = useState(""); // range error message
  const [levels, setLevels] = useState([]); //levels array
  const [discountedPrice, setDiscountedPrice] = useState(""); //discounted price
  const [quantityLevel, setQuantityLevel] = useState("");
  const [levelsErrorMessage, setLevelsErrorMessage] = useState("");
  const [startDateTime, setStartDateTime] = useState(null);
  const [zipinputValue, setZipInputValue] = useState("");
  const [zipCodeValue, setZipCodeValue] = useState([]);

  const [lastRange, setLastRange] = useState({
    quantity_level: "",
    discounted_price: "",
  });
  const [initialValues, setInitialValues] = useState({
    offer_name: "",
    minimum_quantity: "",
    start_date: new Date(),
    end_date: null,
    product_id: "",
    levels: [{ quantity: "", discounted_price: "" }],
    price: "",
    zip_code: [],
    buy_group_shipping_allow: "false",
    influencers: [],
    region: "Nationwide",
    group_type: "Public",
    include_platform_fee: false,
    order_type: null,
  });

  /* const "productOptions" store product list  */
  const [productOptions, setProductOptions] = useState([]);
  const [influencerOptions, setInfluencerOptions] = useState([]);
  const [selectedInfluencers, setSelectedInfluencers] = useState([]);
  const [influencersLoading, setInfluencersLoading] = useState(false);

  /* const "checkedValue" store checkbox value  */
  const [checkedValue, setcheckedValue] = useState(false);

  /*  const "shippingLevel" store shipping range of group*/
  const [shippingLevel, setShippingLevel] = useState([]);

  /*const "deleteRangeModal" responsible for open delete range modal   */
  const [deleteRangeModal, setDeleteRangeModal] = useState(false);

  /* const "deleteRangeId" id Of range that we want to delete */
  const [deleteRangeId, setDeleteRangeId] = useState();

  /* const "groupStartDate" store start date of Group*/
  const [groupStartDate, setgroupStarteDate] = useState(null);

  /* const "groupEndDate" store Max date of Group*/
  const [groupEndDate, setgroupEndDate] = useState(null);

  /* const "disableEndDate" responsible for disable End Date*/
  const [disableEndDate, setdisableEndDate] = useState(true);

  /* const "hideTimeChange" responsible for  hide time change input for end date */
  const [hideTimeChange, sethideTimeChange] = useState(true);

  const [sellingPrice, setSellingPrice] = useState("");

  const [sameEndDate, setSameEndDate] = useState(true);

  const [checkedValuePlatformFee, setCheckedValuePlatformFee] = useState(false);

  //levels array
  useEffect(() => {
    getProductList();
    setdisableEndDate(true);
  }, []);

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleKeyDown = (event, setFieldValue) => {
    if (!zipinputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        const newZipCodeValue = [...zipCodeValue, createOption(zipinputValue)];
        setZipCodeValue(newZipCodeValue);
        setFieldValue("zip_code", newZipCodeValue);
        setZipInputValue("");
        event.preventDefault();
    }
  };

  //this function is used for product list dropdown in create group
  const getProductList = () => {
    setLoading(true);
    const data = {
      supplier_id: null,
      category_id: null,
      sub_category_id: null,
    };
    productList(data)
      .then((response) => {
        if (response.status === 200) {
          let productList = [];
          //here we are creating option for s=product select
          response.data.map((product) => {
            productList.push({
              label: product.product_name,
              value: product.product_id,
              price: product.selling_price,
              lastUpdatedAt: product.amazon_product_price_last_updated_at,
              isAmazonProduct: isAmazonProduct(product.is_amazon_product),
            });
          });
          setProductOptions(productList);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  // fetch influencers for a given product id
  const fetchInfluencersForProduct = (productId) => {
    if (!productId) {
      setInfluencerOptions([]);
      return;
    }
    setInfluencersLoading(true);
    getInfluencersForProducts(productId)
      .then((res) => {
        const data = res?.data || res;
        if (Array.isArray(data)) {
          const options = data.map((p) => ({
            value: p.id,
            label: p.name,
          }));
          setInfluencerOptions(options);
        } else {
          setInfluencerOptions([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching influencers for product:", err);
        setInfluencerOptions([]);
      })
      .finally(() => {
        setInfluencersLoading(false);
      });
  };

  // this fuction is used to create group
  const createGroupFunction = (groupData) => {
    setDisable(true);

    if (typeof groupData.minimum_quantity === "string") {
      groupData.minimum_quantity = parseInt(groupData.minimum_quantity);
    }
    if (typeof groupData.price === "string") {
      groupData.price = parseFloat(groupData.price);
    }

    createGroup(groupData)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message, {
            autoClose: 3000,
            hideProgressBar: true,
          });
          setDisable(false);
          props.history.push(`/app/groups/view/${response.data}`);
        }
      })
      .catch((error) => {
        setDisable(false);
        setErrorMessage(error.data?.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      });
  };

  // this funciton used in product change dropdown takes argument selectedOption {label:'',value:''}
  const handleChangeProduct = (selectedOption, setFieldValue) => {
    setProduct(selectedOption);
    setFieldValue("product_id", selectedOption ? selectedOption.value : "");
    if (isAmazonProduct(selectedOption?.isAmazonProduct)) {
      setFieldValue("order_type", "cxml");
    } else {
      setFieldValue("order_type", null);
    }
    // fetch influencers for the selected product and clear previous selections
    setSelectedInfluencers([]);
    setFieldValue("influencers", []);
    if (selectedOption && selectedOption.value) {
      fetchInfluencersForProduct(selectedOption.value);
    } else {
      setInfluencerOptions([]);
    }
  };

  const handleChangeInfluencers = (selected, setFieldValue) => {
    setSelectedInfluencers(selected || []);
    const values = (selected || []).map((s) => s.value);
    setFieldValue("influencers", values);
  };

  const handleChangeGroupType = (groupType, setFieldValue) => {
    setFieldValue("group_type", groupType);
    if (groupType === "Private") {
      setFieldValue("region", "Zipcodes");
    }
  };

  // this function is used to handle selling price change
  const handleChangeSellingPrice = (event, setFieldValue) => {
    if (!isNaN(event.target.value)) {
      setFieldValue("price", event.target.value);
      setSellingPrice(event.target.value);
      setDiscountedPrice(event.target.value);
    } else {
      event.target.value = "";
      setErrorMessage("Please Enter Numeric Value");
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    }
  };

  const getZipValue = (newValue, setFieldValue) => {
    console.log("newValue", newValue);
    setZipInputValue(newValue);
    console.log("zip_code", zipCodeValue);
  };
  // discount change custom function logic and condition of discount
  const handleChangeDiscount = (event, key) => {
    //check value is number
    if (!isNaN(event.target.value)) {
      //whole number regx

      setDiscountedPrice(event.target.value);
    } else {
      event.target.value = "";
      setDiscountErrorMessage("Please Enter Numeric Value");
      setDiscountedPrice("");
      setTimeout(() => {
        setDiscountErrorMessage("");
      }, 3000);
    }
  };
  // quantity change custom function
  const handleChangeQuantity = (event, key) => {
    if (!isNaN(event.target.value)) {
      //whole number regx
      var rx = new RegExp(/^\d+$/);
      if (!rx.test(event.target.value)) {
        event.target.value = "";
        setDiscountErrorMessage("quantity can not be in decimal");
        setQuantityLevel("");
        setTimeout(() => {
          setDiscountErrorMessage("");
        }, 3000);
      }
      setQuantityLevel(event.target.value);
    } else {
      event.target.value = "";
      setDiscountErrorMessage("Please Enter Numeric Value");
      setQuantityLevel("");
      setTimeout(() => {
        setDiscountErrorMessage("");
      }, 3000);
    }
  };
  // add quantity and shipping range funciton
  const addQuantityrange = () => {
    let rangeObject = {};
    let shippingobj = {};
    if (levels.length === 0) {
      rangeObject["quantity_level"] = quantityLevel;
      rangeObject["discounted_price"] = discountedPrice;
      levels.push(rangeObject);
      setLevels(levels);

      shippingobj["quantity_level"] = quantityLevel;
      shippingobj["shipping_price"] = "0";
      shippingLevel.push(shippingobj);
      setShippingLevel(shippingLevel);

      setLastRange(rangeObject);
      setQuantityLevel("");
      setDiscountedPrice("");
    } else {
      rangeObject["quantity_level"] = quantityLevel;
      rangeObject["discounted_price"] = discountedPrice;
      levels.push(rangeObject);
      setLevels(levels);

      shippingobj["quantity_level"] = quantityLevel;
      shippingobj["shipping_price"] = "0";
      shippingLevel.push(shippingobj);
      setShippingLevel(shippingLevel);

      setLastRange(rangeObject);
      setDiscountedPrice("");
      setQuantityLevel("");
    }
  };
  const handleBlurQuantity = (event) => {
    if (levels.length > 0) {
      if (
        parseInt(lastRange["quantity_level"], 10) <
        parseInt(event.target.value, 10)
      ) {
      } else {
        event.target.value = "";

        setQuantityLevel("");
        setLevelsErrorMessage(
          `Please  enter quantity value greater than ${lastRange["quantity_level"]} `
        );
        setTimeout(() => {
          setLevelsErrorMessage("");
        }, 3000);
      }
    }
  };

  // const handleBlurDiscount = (event) => {
  //   var rx = new RegExp(/^\d+(\.\d{1,2})?$/);
  //   if (rx.test(event.target.value)) {
  //     if (levels.length > 0) {
  //       if (
  //         parseFloat(lastRange["discount_percent"]) <
  //         parseFloat(event.target.value)
  //       ) {
  //       } else {
  //         event.target.value = "";
  //         setDiscountPercent("");
  //         setLevelsErrorMessage(
  //           `Please  enter discount value greater than ${lastRange["discount_percent"]} `
  //         );
  //         setTimeout(() => {
  //           setLevelsErrorMessage("");
  //         }, 3000);
  //       }
  //     }
  //   } else {
  //     event.target.value = "";
  //     setDiscountPercent("");
  //     setLevelsErrorMessage(
  //       ` discount must have 2 digits after decimal or less`
  //     );
  //     setTimeout(() => {
  //       setLevelsErrorMessage("");
  //     }, 3000);
  //   }
  // };

  /* This Function handle quantity range open delete modal*/
  const handleDeleteRange = (e, rowIndex) => {
    setDeleteRangeModal(true);
    setDeleteRangeId(rowIndex);
  };

  const actionFormatter = (cell, row, rowIndex) => (
    <div>
      <span
        className="inline-block pointer-cursor"
        onClick={(e) => handleDeleteRange(e, rowIndex)}
      >
        <i
          className="fa fa-trash"
          style={{
            width: 35,
            fontSize: 20,
            paddingLeft: 11,

            color: "#e4566e",
          }}
        ></i>
      </span>
    </div>
  );

  const quantityFormatter = (cell, row, rowIndex) => (
    <div>
      <span>
        {rowIndex === 0
          ? 1 + " - " + cell
          : parseInt(levels[rowIndex - 1].quantity_level) + 1 + " - " + cell}
      </span>
    </div>
  );

  // columns for bootstrap table
  const columns = [
    {
      dataField: "quantity_level",
      text: "Quantity",

      headerAlign: "right",
      align: "right",
      formatter: quantityFormatter,
    },
    {
      dataField: "discounted_price",
      text: "Price",

      headerAlign: "right",
      align: "right",
      formatter: (cell, row) => {
        return (
          <div className="category_name no-next-line">
            <span> {cell && "$ " + cell}</span>
          </div>
        );
      },
    },
    {
      dataField: "Action",
      text: "Action",
      headerAlign: "center",
      align: "center",
      formatter: actionFormatter,
    },
  ];
  /* This Function handle checkbox  */
  const handleCheckbox = (e, setFieldValue) => {
    const newcheckedvalue = JSON.parse(e.target.value);
    setcheckedValue(!newcheckedvalue);
    setFieldValue("buy_group_shipping_allow", JSON.stringify(!newcheckedvalue));
  };

  /* this function handle shipping cost */
  const handleShippingCost = (evt, index) => {
    const { value } = evt.target;
    const newItems = shippingLevel.map((item, shippingIndex) => {
      if (shippingIndex !== index) {
        return { ...item };
      }
      return { quantity_level: item.quantity_level, shipping_price: value };
    });
    setShippingLevel(newItems);
  };

  /* This function will remove quantity of respective indexId */
  const removeQuantity = (rowIndex) => {
    levels.length = rowIndex;
    setLevels(levels);
    shippingLevel.length = rowIndex;
    setShippingLevel(shippingLevel);
    setDeleteRangeModal(false);
    if (rowIndex > 0) {
      setLastRange(levels[rowIndex - 1]);
    }
    if (levels.length > 0) {
      setDiscountedPrice("");
    } else {
      setDiscountedPrice(sellingPrice);
    }
  };
  /** This Function will handle group start date
  @param selectedStartDate start date
 */
  const handleGroupStartDate = (selectedStartDate, setFieldValue) => {
    if (selectedStartDate !== null) {
      let groupMaxDate = new Date(
        selectedStartDate.getFullYear(),
        selectedStartDate.getMonth(),
        selectedStartDate.getDate() + 6
      );
      setgroupStarteDate(selectedStartDate);
      setgroupEndDate(groupMaxDate);
      setdisableEndDate(false);
    } else {
      setdisableEndDate(true);
      setgroupStarteDate(null);
      setgroupEndDate(null);
    }
    setFieldValue("start_date", selectedStartDate);
    setFieldValue("end_date", null);
  };

  /**
   * This Function will handle group end date
   * @param SelectedEndDate end date
   */
  const handleGroupEndDate = (SelectedEndDate, setFieldValue) => {
    setSameEndDate(true);
    // if(SelectedEndDate.getDate()===groupStartDate.getDate()){
    //       console.log("same date")
    //       setSameEndDate(false)
    // }

    if (SelectedEndDate !== null && groupEndDate !== null) {
      if (SelectedEndDate.getDate() === groupEndDate.getDate()) {
        sethideTimeChange(false);
        if (
          moment(SelectedEndDate).format("HH:mm") >
          moment(groupStartDate).format("HH:mm")
        ) {
          SelectedEndDate.setHours(0, 0, 0, 0);
        }
      } else {
        sethideTimeChange(true);
      }
    }
    setFieldValue("end_date", SelectedEndDate);
  };

  /**
   * This Function will handle filter time
   * @param time current time
   */
  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    // console.log(
    //   "filterPassedTime",
    //   currentDate.getTime(),
    //   selectedDate.getTime()
    // );

    return currentDate.getTime() < selectedDate.getTime();
  };

  const handleCheckboxPlatformFee = (e, setFieldValue) => {
    console.log("e.target.value", e.target.value);
    const newcheckedvalue = JSON.parse(e.target.value);
    console.log("newcheckedvalue", newcheckedvalue);
    setCheckedValuePlatformFee(!newcheckedvalue);
    setFieldValue("include_platform_fee", !newcheckedvalue);
  };

  const dateFormatter = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.slice(0, 10);
    const [year, month, day] = date.split("-");
    return `${month}/${day}/${year}`;
  };

  //current Date
  const currentDate = new Date();
  let tomorrow = new Date();
  tomorrow.setDate(currentDate.getDate());

  return (
    <>
      <Breadcrumbs
        title="Add BuyGroup"
        parent="BuyGroup"
        subtitle="BuyGroup Admin Panel"
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <h5>Add BuyGroup</h5>
              </CardHeader>
              <CardBody>
                {isLoading ? (
                  <div className="custom-loader">
                    <Spinner animation="border" />
                  </div>
                ) : (
                  <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={(values, actions) => {
                      const selectedProductIsAmazon = isAmazonProduct(
                        selectedProduct?.isAmazonProduct
                      );
                      let newValues = {
                        ...values,
                        order_type: selectedProductIsAmazon
                          ? values.order_type || "cxml"
                          : null,
                      };
                      if (newValues.group_type === "Private") {
                        newValues.region = "Zipcodes";
                      }
                      // console.log("newValues", newValues);
                      if (Array.isArray(newValues.zip_code)) {
                        let zipcodeArray = newValues?.zip_code?.map(
                          (a) => a.value
                        );
                        const ZipResult = zipcodeArray.toString();
                        newValues.zip_code = ZipResult;
                      }

                      // console.log("myaval", newValues);
                      if (levels.length === 0 || shippingLevel.length === 0) {
                        setLevelsErrorMessage(
                          "Please Enter range and discount"
                        );
                        setTimeout(() => {
                          setLevelsErrorMessage("");
                        }, 3000);
                      } else {
                        newValues.levels = levels;
                        if (checkedValue === false) {
                          newValues.shipping_level = shippingLevel;
                        }
                        newValues = trimObj(newValues);
                        newValues.start_date = values.start_date;
                        newValues.end_date = values.end_date;
                        console.log("newValues", newValues);
                        if (
                          isPriceGreaterThanSellingPrice(levels, newValues.price)
                        ) {
                          console.log(
                            "if discount is greater than product price"
                          );
                          setErrorMessage(
                            "Discount cannot be greater than price"
                          );
                          setTimeout(() => setErrorMessage(""), 3000);
                        } else {
                          console.log(
                            "else discount is not greater than product price"
                          );
                          createGroupFunction(newValues);
                        }
                      }
                    }}
                    validationSchema={validationSchema}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      resetForm,
                      setFieldValue,
                    }) => (
                      <form
                        className="needs-validation add-product-form"
                        onSubmit={handleSubmit}
                      >
                      {influencersLoading && (
                        <div className="influencer-loading-overlay">
                          <div className="spinner-border text-light" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      )}
                        {/* {console.log("formvalue", values, errors)} */}
                        {errorMessage !== undefined && errorMessage !== "" ? (
                          <p className="alert alert-danger">{errorMessage}</p>
                        ) : (
                          ""
                        )}

                        <Row className="product-adding">
                          <Col xl="12">
                            <div className="form form-label-center">
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Group Name
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <Input
                                    className="form-control"
                                    name={`offer_name`}
                                    type="text"
                                    placeholder="Group Name"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <ErrorMessage name={`offer_name`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Select Product
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <Select
                                    name="product_id"
                                    className="zIndexIncrease suppliers_dropdown"
                                    value={selectedProduct}
                                    onChange={(selectedOption) => {
                                      handleChangeProduct(
                                        selectedOption,
                                        setFieldValue
                                      );
                                    }}
                                    options={productOptions}
                                    placeholder="Select Product"
                                  />

                                  {selectedProduct &&
                                    isAmazonProduct(selectedProduct.isAmazonProduct) && (
                                      <div className="product_price_container">
                                        <strong>
                                          Product Price:&nbsp;{selectedProduct.price}
                                        </strong>
                                        <strong>
                                          Last Updated At:&nbsp;
                                          {dateFormatter(
                                            selectedProduct.lastUpdatedAt
                                          )}
                                        </strong>
                                      </div>
                                    )}

                                  <ErrorMessage name="product_id">
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              {selectedProduct &&
                                isAmazonProduct(selectedProduct.isAmazonProduct) && (
                                  <FormGroup className="form-group mb-3 row">
                                    <Label className="col-xl-3 col-sm-3 mb-0">
                                      Order Type
                                    </Label>
                                    <div className="col-xl-9 col-sm-9">
                                      <FormGroup className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                                        <Label className="d-block mb-0">
                                          <Input
                                            className="radio_animated"
                                            type="radio"
                                            name="order_type"
                                            value="cxml"
                                            checked={
                                              values.order_type === "cxml"
                                            }
                                            onChange={() =>
                                              setFieldValue(
                                                "order_type",
                                                "cxml"
                                              )
                                            }
                                          />
                                          cXML
                                        </Label>
                                        <Label className="d-block mb-0">
                                          <Input
                                            className="radio_animated"
                                            type="radio"
                                            name="order_type"
                                            value="json"
                                            checked={
                                              values.order_type === "json"
                                            }
                                            onChange={() =>
                                              setFieldValue(
                                                "order_type",
                                                "json"
                                              )
                                            }
                                          />
                                          JSON
                                        </Label>
                                      </FormGroup>
                                    </div>
                                  </FormGroup>
                                )}
                              {influencerOptions &&
                                influencerOptions.length > 0 && (
                                  <FormGroup className="form-group mb-3 row">
                                    <Label className="col-xl-3 col-sm-3 mb-0">
                                      Select Influencers
                                    </Label>
                                    <div className="col-xl-9 col-sm-9">
                                    <Select
                                        name="influencers"
                                        isMulti
                                        className="zIndexIncrease vendors_dropdown"
                                      value={selectedInfluencers}
                                      onChange={(selected) =>
                                        handleChangeInfluencers(
                                          selected,
                                          setFieldValue
                                        )
                                      }
                                        options={influencerOptions}
                                        placeholder="Select Influencers"
                                      isDisabled={influencersLoading}
                                    />
                                      <ErrorMessage name="influencers">
                                        {(msg) => (
                                          <div className="input-feedback">
                                            {msg}
                                          </div>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                  </FormGroup>
                                )}
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Minimum Quantity
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <Input
                                    className="form-control"
                                    name={`minimum_quantity`}
                                    type="text"
                                    placeholder="minimum Quantity"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <ErrorMessage name={`minimum_quantity`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Selling Price
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <Input
                                    className="form-control"
                                    name={`price`}
                                    type="text"
                                    placeholder="Selling Price"
                                    onChange={(event) => handleChangeSellingPrice(event, setFieldValue)}
                                    onBlur={handleBlur}
                                  />
                                  <ErrorMessage name={`price`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>

                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Visibility
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <FormGroup className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                                    <Label className="d-block mb-0">
                                      <Input
                                        className="radio_animated"
                                        type="radio"
                                        name="group_type"
                                        value="Public"
                                        checked={values.group_type === "Public"}
                                        onChange={() =>
                                          handleChangeGroupType(
                                            "Public",
                                            setFieldValue
                                          )
                                        }
                                      />
                                      Public
                                    </Label>
                                    <Label className="d-block mb-0">
                                      <Input
                                        className="radio_animated"
                                        type="radio"
                                        name="group_type"
                                        value="Private"
                                        checked={values.group_type === "Private"}
                                        onChange={() =>
                                          handleChangeGroupType(
                                            "Private",
                                            setFieldValue
                                          )
                                        }
                                      />
                                      Private
                                    </Label>
                                  </FormGroup>
                                </div>
                              </FormGroup>

                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Region
                                </Label>
                                <div className="col-xl-9 col-sm-9">
                                  <FormGroup className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                                    {values.group_type !== "Private" && (
                                      <Label className="d-block mb-0">
                                        <Input
                                          className="radio_animated"
                                          type="radio"
                                          name="region"
                                          value="Nationwide"
                                          checked={
                                            values.region === "Nationwide"
                                          }
                                          onChange={() => {
                                            setFieldValue(
                                              "region",
                                              "Nationwide"
                                            );
                                            setZipCodeValue([]);
                                            setFieldValue("zip_code", []);
                                          }}
                                        />
                                        Nationwide
                                      </Label>
                                    )}
                                    <Label className="d-block mb-0">
                                      <Input
                                        className="radio_animated"
                                        type="radio"
                                        name="region"
                                        value="Zipcodes"
                                        checked={values.region === "Zipcodes"}
                                        onChange={() =>
                                          setFieldValue("region", "Zipcodes")
                                        }
                                      />
                                      Zipcodes
                                    </Label>
                                  </FormGroup>
                                </div>
                              </FormGroup>

                              {values.region === "Zipcodes" && (
                                <FormGroup className="form-group mb-3 row">
                                  <Label className="col-xl-3 col-sm-3 mb-0">
                                    Zip Codes
                                  </Label>
                                  <div className="col-xl-9 col-sm-9">
                                    <CreatableSelect
                                      inputValue={zipinputValue}
                                      name="zip_code"
                                      isClearable
                                      isMulti
                                      menuIsOpen={false}
                                      onInputChange={(newValue) => {
                                        getZipValue(newValue, setFieldValue);
                                      }}
                                      onChange={(newValue) => {
                                        const selectedZipCodes =
                                          newValue || [];
                                        setZipCodeValue(selectedZipCodes);
                                        setFieldValue(
                                          "zip_code",
                                          selectedZipCodes
                                        );
                                      }}
                                      onKeyDown={(event) =>
                                        handleKeyDown(event, setFieldValue)
                                      }
                                      placeholder="Type zip code and press enter..."
                                      value={zipCodeValue}
                                    />
                                    <ErrorMessage name={`zip_code`}>
                                      {(msg) => (
                                        <div className="input-feedback">
                                          {msg}
                                        </div>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </FormGroup>
                              )}
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  Start Date
                                </Label>
                                <div className="col-xl-9 col-sm-9 full_width_date">
                                  <DatePicker
                                    selected={
                                      values.start_date
                                        ? new Date(values.start_date)
                                        : null
                                    }
                                    onChange={(selectedDate) =>
                                      handleGroupStartDate(
                                        selectedDate,
                                        setFieldValue
                                      )
                                    }
                                    selectsStart
                                    startDate={values.start_date}
                                    endDate={values.end_date}
                                    // showTimeInput
                                    showTimeSelect
                                    timeInputLabel="Time:"
                                    placeholderText="Start Date"
                                    dateFormat="MM/dd/yyyy  h:mm aa"
                                    className="form-control"
                                    name="end_date"
                                    timeIntervals={15}
                                    minDate={tomorrow}
                                    filterTime={filterPassedTime}
                                  // showTimeSelect={true}
                                  />
                                  <ErrorMessage name={`start_date`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-3 mb-0">
                                  End Date
                                </Label>
                                <div className="col-xl-9 col-sm-9 full_width_date">
                                  <DatePicker
                                    selected={
                                      values.end_date
                                        ? new Date(values.end_date)
                                        : null
                                    }
                                    // onChange={(val) => {
                                    //   setFieldValue("end_date", val);
                                    // }}
                                    onChange={(selecteDate) =>
                                      handleGroupEndDate(
                                        selecteDate,
                                        setFieldValue
                                      )
                                    }
                                    selectsEnd
                                    disabled={disableEndDate}
                                    startDate={values.start_date}
                                    endDate={values.end_date}
                                    minDate={groupStartDate}
                                    maxDate={groupEndDate}
                                    //  showTimeInput={hideTimeChange}
                                    showTimeSelect
                                    timeIntervals={15}
                                    minTime={setHours(
                                      setMinutes(setSeconds(new Date(), 0), 0),
                                      0
                                    )}
                                    // minTime={groupStartDate}
                                    maxTime={
                                      hideTimeChange
                                        ? setHours(
                                          setMinutes(
                                            setSeconds(new Date(), 59),
                                            59
                                          ),
                                          23
                                        )
                                        : groupStartDate
                                    }
                                    filterTime={filterPassedTime}
                                    timeInputLabel="Time:"
                                    placeholderText="End Date"
                                    dateFormat="MM/dd/yyyy  h:mm aa"
                                    className="form-control"
                                    name="end_date"
                                  />
                                  <ErrorMessage name="end_date">
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-2 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Add Quantity Range
                                </Label>
                                <Col md="3">
                                  <Input
                                    className="form-control"
                                    type="text"
                                    placeholder=" Range"
                                    name="Quantity"
                                    value={quantityLevel}
                                    onChange={handleChangeQuantity}
                                    onBlur={handleBlurQuantity}
                                  />
                                </Col>

                                <Col md="3">
                                  <Input
                                    className="form-control"
                                    type="text"
                                    name="discounted_price"
                                    placeholder="Price"
                                    value={discountedPrice}
                                    // onBlur={handleBlurDiscount}
                                    onChange={handleChangeDiscount}
                                    disabled={levels.length > 0 ? false : true}
                                  />
                                  <ErrorMessage name={`discounted_price`}>
                                    {(msg) => (
                                      <div className="input-feedback">
                                        {msg}
                                      </div>
                                    )}
                                  </ErrorMessage>
                                </Col>
                                <FormGroup className="form-group  ml-2 row">
                                  <Button
                                    type="button"
                                    disabled={
                                      discountedPrice !== "" &&
                                        quantityLevel !== ""
                                        ? false
                                        : true
                                    }
                                    onClick={addQuantityrange}
                                  >
                                    Add Quantity+
                                  </Button>
                                </FormGroup>
                              </FormGroup>
                              {discountErrorMessage && (
                                <div className="offset-xl-3 offset-sm-4">
                                  <label className="err-msg">
                                    {discountErrorMessage &&
                                      discountErrorMessage}
                                  </label>
                                </div>
                              )}
                              {levelsErrorMessage && (
                                <div className="offset-xl-3 offset-sm-4">
                                  <label className="err-msg">
                                    {levelsErrorMessage && levelsErrorMessage}
                                  </label>
                                </div>
                              )}
                              <FormGroup className="form-group mb-3 row">
                                <div className="offset-xl-3 offset-sm-4 col-md-6">
                                  {levels.length > 0 && (
                                    <BootstrapTable
                                      keyField="id"
                                      key={`levelsTable`}
                                      striped
                                      hover
                                      condensed
                                      bordered={true}
                                      data={levels}
                                      columns={columns}
                                      rowClasses="row-hover"
                                    />
                                  )}
                                </div>
                                {checkedValue == false && levels.length > 0 && (
                                  <div>
                                    <Label
                                      style={{
                                        marginTop: "0px",
                                        padding: "13px 0px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Add Shipping Range ($)
                                    </Label>
                                    <table>
                                      {shippingLevel.map(
                                        (shippinglevel, index) => {
                                          return (
                                            <tr key={index}>
                                              <td>
                                                <Input
                                                  className="form-control"
                                                  style={{
                                                    maxWidth: "100px",
                                                  }}
                                                  value={
                                                    shippinglevel.quantity_level
                                                  }
                                                  disabled
                                                  type="hidden"
                                                />
                                              </td>
                                              <td>
                                                <Input
                                                  type="text"
                                                  style={{
                                                    marginTop: "4px",
                                                    marginBottom: "4px",
                                                    maxWidth: "100px",
                                                  }}
                                                  value={
                                                    shippinglevel.shipping_price
                                                  }
                                                  className="form-control"
                                                  onChange={(evt) =>
                                                    handleShippingCost(
                                                      evt,
                                                      index
                                                    )
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </table>
                                  </div>
                                )}
                              </FormGroup>

                              <FormGroup>
                                <Input
                                  type="checkbox"
                                  name="buy_group_shipping_allow"
                                  value={checkedValue}
                                  checked={checkedValue}
                                  onChange={(e) =>
                                    handleCheckbox(e, setFieldValue)
                                  }
                                />{" "}
                                <label style={{ marginTop: "0" }}>
                                  Want to use shippo service?
                                </label>
                              </FormGroup>

                              <FormGroup>
                                <Input
                                  type="checkbox"
                                  name="include_platform_fee"
                                  value={checkedValuePlatformFee}
                                  checked={checkedValuePlatformFee}
                                  onChange={(e) =>
                                    handleCheckboxPlatformFee(e, setFieldValue)
                                  }
                                />
                                <label style={{ marginTop: "0" }}>
                                  Want to include platform fee?
                                </label>
                              </FormGroup>

                              {deleteRangeModal && (
                                <DeleteQuantity
                                  deleteRangeModal={deleteRangeModal}
                                  removeQuantity={removeQuantity}
                                  deleteRangeId={deleteRangeId}
                                  closedDeleteModal={() =>
                                    setDeleteRangeModal(false)
                                  }
                                />
                              )}
                            </div>

                            <div className="offset-xl-3 offset-sm-4">
                              <Button
                                type="submit"
                                color="primary"
                                onClick={handleSubmit}
                                disabled={isDisable || influencersLoading}
                              >
                                {isDisable ? "Please Wait" : "Add"}
                              </Button>
                              <Link to="/app/groups">
                                <Button type="button" color="light">
                                  Cancel
                                </Button>
                              </Link>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    )}
                  </Formik>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddGroup;
/* Copyright Information: Created by BuyGroup */
